export const GroupHeaders = [
  {
    name: "Name",
    field: "name",
    align: "left",
    sorting: false,
  },
  {
    name: "Contacts",
    field: "contacts",
    align: "left",
    sorting: false,
  },
];
